import React, { Suspense } from "react";
import PageSpinner from "./PageSpinner/PageSpinner";
// import ErrorBoundary from "antd/lib/alert/ErrorBoundary";
// import RestrictedAccessPage from "../views/errors/RestrictedAccessPage";
import { ErrorBoundary } from 'react-error-boundary';
import SomethingWentWrong from "../views/errors/SomethingWentWrong";

const ModuleWrap: React.FC<any> = ({ module: Module, ...rest }) => {

  return (
    <Suspense fallback={<PageSpinner />}>

      <ErrorBoundary FallbackComponent={SomethingWentWrong}>
        <div className="mainPageWrap">
          <Module permissions={""} {...rest} />
        </div>
      </ErrorBoundary>
    </Suspense>
  );
};

export default ModuleWrap;
